import { Z_INDEX_DEMO_EXIT_CONFIRMATION } from '../../../constants/z_index';
export const getStyle = () => ({
  top: 0,
  position: 'absolute',
  height: '100vh',
  width: '100vw',
  zIndex: Z_INDEX_DEMO_EXIT_CONFIRMATION,
  backgroundColor: 'transparent',
  left: 0,
  border: 'none',
  display: 'none'
});